import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "area-images" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "text-h6"
}

import { IOverlayImage } from '@/types';
import { withDefaults } from 'vue';



interface IProps {
  images: IOverlayImage[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomAvatarOverlay',
  props: {
    images: {}
  },
  emits: ['onClick'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

function handleCLick(item: IOverlayImage) {
  emit('onClick', item)
}


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.images, (item, index) => {
      return (_openBlock(), _createBlock(_component_v_avatar, {
        key: String(index),
        color: "grey",
        size: "35",
        rounded: "8",
        class: "image",
        style: _normalizeStyle({ left: `${index * 20}px` }),
        onClick: ($event: any) => (handleCLick(item))
      }, {
        default: _withCtx(() => [
          (item.url.includes('http'))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                style: {"height":"100%","width":"100%"},
                src: item.url,
                alt: item.url,
                crossorigin: "anonymous"
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.url.toUpperCase()), 1))
        ]),
        _: 2
      }, 1032, ["style", "onClick"]))
    }), 128))
  ]))
}
}

})